import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [me, setMe] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setMe(data);
      return data;
    } catch (e) {
      try {
        await api.post("/auth/refresh");
        const { data } = await api.get("/auth/me");
        setMe(data);
        return data;
      } catch (err) {
        setMe(false);
        return false;
      }
    }
  }, []);

  useEffect(() => {
    refresh();
    const onExpired = () => setMe(false);
    window.addEventListener("auth:expired", onExpired);
    return () => window.removeEventListener("auth:expired", onExpired);
  }, [refresh]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setMe(false);
  };

  const can = (perm) => !!me && me.permissions?.includes(perm);
  const hasModule = (code) => !!me && me.modules?.some((m) => m.code === code);

  return <AuthContext.Provider value={{ me, setMe, refresh, logout, can, hasModule }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);

export const homeFor = (me) => (me?.space === "platform" ? "/admin" : me?.space === "tenant" ? "/cabinet" : "/connexion");
